export type SpamListEntrySourceMethod = 'Manual' | 'Automatic'

export type SpamListEntrySource = {
  method: SpamListEntrySourceMethod
  conversationId?: number
  messageId?: number
  participantId?: number
  leadId?: number
}

export type SpamReportCategory = 'Phishing' | 'IllegalContent' | 'Spam' | 'Safe'

export const SpamSourceMapping: Record<string, string> = {
  EntitySpamList: 'Manual',
  WhiteList: 'Whitelist',
  BlackList: 'Blacklist',
  CleanTalk: 'CleanTalk',
  OOPSpam: 'OOPSpam',
  SpamReportScoring: 'MandrillSpamReport',
  AutomaticRules: 'Automatic',
  AIModel: 'AI',
}

export const SpamReasonMapping: Record<string, SpamReportCategory> = {
  Blacklisted: 'Spam',
  LeadsPerUserPerDay: 'Spam',
  LeadsPerMinute: 'Spam',
  LeadsPerHour: 'Spam',
  LeadsPerDay: 'Spam',
  DisposableEmail: 'Spam',
  BlacklistedInAntiSpamService: 'Spam',
  SpamEmail: 'Spam',
  ContainsLinks: 'Spam',
  FastSubmit: 'Spam',
  SpamIP: 'Spam',
  SpamMessage: 'Spam',

  Phishing: 'Phishing',

  HateContent: 'IllegalContent',
  ViolenceContent: 'IllegalContent',
  SelfharmContent: 'IllegalContent',
  SexualContent: 'IllegalContent',
  IllegalContent: 'IllegalContent',

  Whitelisted: 'Safe',
}
